import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim"; 
import HeroSection from '../components/HeroSection/HeroSection';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import GrcSection from '../components/GrcSection/GrcSection';
import StatsSection from '../components/StatsSection/StatsSection';
import IndustriesSection from '../components/IndustriesSection/IndustriesSection';
import TestimonialsSection from '../components/TestimonialsSection/TestimonialsSection';
import CtaSection from '../components/CtaSection/CtaSection';
import './HomePage.css'; // Import the new CSS file

const HomePage = () => {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="homepage-wrapper">
      <Particles
        id="tsparticles"
        className="particles-background"
        init={particlesInit}
        options={{
          background: {
            color: {
              value: "#000000",
            },
          },
          fpsLimit: 60,
          interactivity: {
            events: {
              onHover: {
                enable: true,
                mode: "repulse",
              },
              resize: true,
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 200,
              enable: true,
              opacity: 0.2,
              width: 1,
            },
            move: {
              enable: true,
              speed: 5,
            },
            number: {
              density: {
                enable: true,
                area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.2,
            },
            shape: {
              type: "circle",
            },
            size: {
              value: { min: 1, max: 3 },
            },
          },
          detectRetina: true,
        }}
      />
      <HeroSection />
      <WhyChooseUs />
      <GrcSection />
      <StatsSection />
      <IndustriesSection />
      <TestimonialsSection />
      <CtaSection />
    </div>
  );
};

export default HomePage;
